import { render, staticRenderFns } from "./CloseIdvProcess.vue?vue&type=template&id=224a4c8e&scoped=true"
import script from "./CloseIdvProcess.vue?vue&type=script&lang=js"
export * from "./CloseIdvProcess.vue?vue&type=script&lang=js"
import style0 from "./CloseIdvProcess.vue?vue&type=style&index=0&id=224a4c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224a4c8e",
  null
  
)

export default component.exports